/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { NumberBox, NumberBoxComponentSpacing, NumberBoxLayoutStyle } from './NumberBox';
import { KeyUpEvent } from 'devextreme/ui/number_box';
import '../../../scss/controls/_moneybox.scss';

interface MoneyBoxProps {
    id?: string;
    dataTestid?: string;
    value?: number;
    allowNegative?: boolean;
    displayChange?: boolean;
    format?: string;
    readOnly?: boolean;
    disabled?: boolean;
    label?: string;
    helperText?: React.ReactNode;
    required?: boolean;
    requiredMessage?: string;
    children?: React.ReactNode;
    validator?: React.ReactNode;
    width?: string;
    min?: number;
    max?: number;
    mask?: string;
    maskInvalidMessage?: string;
    onChange: (value: number) => void;
    onEnterKey?: () => void;
    onKeyUp?: ((e: KeyUpEvent) => void) | undefined;
    validateValue?: (value: string) => boolean;
    onValidationEvent?: (isValid: boolean) => void;
    validateValueMessage?: string;
    componentSpacing?: NumberBoxComponentSpacing;
    liveUpdate?: boolean;
    showInfoIcon?: boolean;
    infoText?: React.ReactNode;
    /** Label above the input (Vertical, default) or beside it (Horizontal). */
    layoutStyle?: NumberBoxLayoutStyle;
    /** Width of the label column when layoutStyle is Horizontal. Defaults to 120px. */
    labelWidth?: string;
    /** Total height of the input box, border included (e.g. '36px'). Omit to keep the default height. */
    height?: string;
}

export const MoneyBox: React.FC<MoneyBoxProps> = ({
    id,
    dataTestid,
    value,
    allowNegative = false,
    displayChange = false,
    format = '$ #,##0',
    mask,
    maskInvalidMessage,
    readOnly = false,
    disabled = false,
    label,
    helperText,
    required = false,
    requiredMessage,
    children,
    validator,
    width = 'auto',
    min,
    max,
    onChange,
    onEnterKey,
    validateValue,
    onValidationEvent,
    validateValueMessage,
    componentSpacing,
    liveUpdate,
    showInfoIcon = false,
    infoText,
    layoutStyle,
    labelWidth,
    height,
}) => {
    return (
        <NumberBox
            id={id}
            label={label}
            helperText={helperText}
            allowNegative={allowNegative}
            data-testid={dataTestid}
            format={displayChange ? '$ #,##0.00' : format}
            mask={mask}
            maskInvalidMessage={maskInvalidMessage}
            value={value}
            disabled={disabled}
            required={required}
            requiredMessage={requiredMessage}
            onChange={onChange}
            readOnly={readOnly}
            width={width}
            min={min}
            max={max}
            onEnterKey={onEnterKey}
            validateValue={validateValue}
            validateValueMessage={validateValueMessage}
            validator={validator}
            onValidationEvent={onValidationEvent}
            componentSpacing={componentSpacing}
            liveUpdate={liveUpdate}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
            layoutStyle={layoutStyle}
            labelWidth={labelWidth}
            height={height}
        >
            {children}
        </NumberBox>
    );
};
